<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li><router-link to="/layout/institution-list">会员风采</router-link></li>
                <li><router-link :to="`/layout/cultural-heritage-list?page=${page}`">非物质文化遗产</router-link></li>
                <li class="currentNode"><a>非物质文化遗产详情</a></li>
            </ul>
            <div class="page-main">
                <h4>
                    <span>{{ title }}</span>
                    <!-- <span class="food-tag">有包间</span> -->
                </h4>
                <el-divider></el-divider>
               <div class="city-des content-detail" v-html="content"></div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getPlolicyDetail
} from '@services/indexService.js'

export default {
    name:"",
    data() {
        return {
            detailId: '',
            page: '',
            title: '',
            subTitle: '',
            tagList: [],
            createTime: '',
            imageUrl: '',
            tel: '',
            homeAddress:'',
            avgPrice: '',
            description: '',
            recommendationList: [],
            content:'',
            publishTime: '',
        }
    },
    created() {
        this.detailId = this.$route.query.id;
        this.page = this.$route.query.page;
        this.getPlolicyDetail(this.detailId);
    },
    methods: {
        getPlolicyDetail(id) {
            let params = {
                id: id
            };
            getPlolicyDetail(params).then(res => {
                console.log(res);
                if (res.Code === 1 && res.Data !== null && res.Data.length!==0) {
                    this.content = res.Data.Content;
                    this.title = res.Data.Title;
                    this.publishTime = res.Data.UpdateTime;
                    // this.subTitle = res.Data.SubTitle;
                    // this.tagList = res.Data.lstSubTitle;
                    // this.createTime = res.Data.CreateTime;
                    // this.imageUrl = res.Data.ImageUrl;
                    // this.tel = res.Data.Tel;
                    // this.homeAddress = res.Data.HomeAddress;
                    // this.avgPrice = res.Data.AvgPrice;
                    // this.description = res.Data.Description;
                    // this.recommendationList = res.Data.ListImage;
                } else {
                    this.$message.error("协会要问请求失败");
                }
            })

        }
    }
}
</script>
<style src="../../assets/css/articleDetail.css" scoped></style>
<style scoped>
.page-main h4 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #262626;
    font-size: 26px;
    margin-bottom: 20px;
}
</style>